var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgVisibilityFill1Wght400Grad0Opsz40(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    height: 40,
    width: 40,
    fill: "#f2c139",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20 26.375q3 0 5.104-2.104t2.104-5.104q0-3-2.104-5.104Q23 11.958 20 11.958t-5.104 2.105q-2.104 2.104-2.104 5.104t2.104 5.104Q17 26.375 20 26.375Zm0-2.583q-1.917 0-3.271-1.354-1.354-1.355-1.354-3.271 0-1.917 1.354-3.271 1.354-1.354 3.271-1.354 1.917 0 3.271 1.354 1.354 1.354 1.354 3.271 0 1.916-1.354 3.271-1.354 1.354-3.271 1.354Zm0 7.875q-6.083 0-11.021-3.438-4.937-3.437-7.312-9.062 2.375-5.625 7.312-9.063Q13.917 6.667 20 6.667q6.083 0 11.021 3.437 4.937 3.438 7.312 9.063-2.375 5.625-7.312 9.062Q26.083 31.667 20 31.667Z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgVisibilityFill1Wght400Grad0Opsz40);
export default __webpack_public_path__ + "static/media/visibility_FILL1_wght400_GRAD0_opsz40.67009101eafbb5cd91aa329fa59a104e.svg";
export { ForwardRef as ReactComponent };